<template>
  <div>
    <div
      v-if="loading === true"
      class="spinner-grow text-primary"
      style="margin-top: 15%;margin-left: 45%;"
    />
    <div
      v-if="loading === false"
      class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button">
        <button
          id="deleteMultiple"
          type="button"
          class="btn btn-outline-primary mb-2 mr-1"
          @click="confirmDeleteText(deletedArry)"
        >
          Delete Selected Elements
        </button>
        <button
          type="button"
          class="btn btn-primary mb-2"
          data-toggle="modal"
          data-target="#createModal"
        >
          Create
        </button>
        <create
          v-if="$router.currentRoute.name === 'contract-invoices'"
          @refresh="renderTable()"
        />
      </div>
    </div>
    <basic-table
      v-if="loading === false"
      :columns="columns"
      :values="rows"
      :actions-obj="actionsArray"
      @choosenObject="getEditedObject($event)"
      @dynamicAction="handleActions($event)"
      @deleteItems="removeItems($event)"
      @deletedMultipleIds="catchIds($event)"
    />
    <edit
       v-if="$router.currentRoute.name === 'contract-invoices'"
       :invoice="editedInvoice"
       @refresh="renderTable()"
    />
  </div>
</template>
<script>
import BasicTable from '../../../../../shared/tables/BasicTable.vue'
import Create from './create.vue'
import Edit from './edit.vue'
import invoiceService from '@/services/invoiceService'

export default {
  components: {
    Create,
    Edit,
    BasicTable,
  },
  data() {
    return {
      loading: false,
      forRefresh: '',
      actionsArray: [],
      editedInvoice: '',
      columns: [
        {
          label: 'Reference Number',
          field: 'referenceNumber',
        },
        {
          label: 'Title',
          field: 'title',
        },
        {
          label: 'Price',
          field: 'price',
        },
        {
          label: 'Status',
          field: 'status.name',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  watch: {
    forRefresh(val) {
      this.getInvoices(this.$route.params.id)
    },
  },
  created() {
    this.getInvoices(this.$route.params.id)
    this.actionsArray = [{ title: 'Payments', icon: 'DollarSignIcon' }]
  },
  methods: {
    getInvoices(id) {
      this.loading = true
      invoiceService.index(id).then(response => {
        this.rows = response.data.data
        this.loading = false
        console.log('%%%%%%%%%%%%%%', this.rows)
        console.log(this.rows)
        console.log(this.columns)
      })
    },
    handleActions(itemObj) {
      console.log(itemObj)
      switch (itemObj.key) {
        case 'Payments':
          this.$router.push({ name: 'invoice-payments', params: { id: itemObj.id } })
          break
        default:
          console.log('Action Object *******>', itemObj)
      }
      // this.$router.push({ name: 'representatives', params: { id: itemId } })
    },
    getEditedObject(obj) {
      this.editedInvoice = obj
      console.log('======>', this.editedInvoice)
    },
    catchVar(e) {
      this.forRefresh = e
    },
    catchIds(ids) {
      this.deletedArry = ids
    },
    removeItems(arr) {
      this.loading = true
      this.confirmDeleteText(arr)
    },
    confirmDeleteText(arr) {
      console.log('arr', arr.length)
      if (arr.length > 0) {
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            invoiceService.delete(this.$route.params.id, arr.join()).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Your Items have been deleted.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.renderTable()
                })
              }
            }).catch(error => Promise.reject(error))
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    },
    renderTable() {
      this.getInvoices(this.$route.params.id)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
